import { ThemeEvents } from '@theme/events';

class VariantDescription extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(ThemeEvents.variantUpdate, this.updateDescription);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(ThemeEvents.variantUpdate, this.updateDescription);
  }

  updateDescription = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const selector = `variant-description[data-product-id="${this.dataset.productId}"] [data-variant-description]`;
    const next = event.detail.data.html.querySelector(selector);
    const current = this.querySelector('[data-variant-description]');
    if (!next || !current) return;
    current.replaceWith(next.cloneNode(true));
  };
}

if (!customElements.get('variant-description')) {
  customElements.define('variant-description', VariantDescription);
}
